import * as axios from 'axios';
import { API } from '../config/config';


const attachFiles = async function (captcha, otp, phone, optId, files) {
	try {
		console.log("files", files);
		let formData = new FormData();
		formData.append("captcha", captcha);
		formData.append("otp", otp);
		formData.append("phone", phone);
		formData.append("optId", optId);
		for (let i = 0; i < files.length; i++) { formData.append("file", files[i]); }
		const response = await axios.post(`${API}/Attachment/AttachFiles`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
		return response;
	} catch (err) {
		throw new Error(err)
	}
};


export const attachmentsService = {
	attachFiles
};
